module.exports = __webpack_public_path__ + "img/livesession_white.01484878.svg";